export const changeRequestDetails = (data: any) => ({
    type: "CHANGE_REQUEST_DETAIL",
    payload: data,
  });
  export const changeRequestPageSize = (pageSize: any) => ({
    type: "CHANGE_REQUEST_LIST_PAGESIZE",
    payload: pageSize,
  });
  